import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useId } from '@reach/auto-id';
import React from 'react';

export interface IMultiSelectChipProps<T> {
    option: T,
    index: number,
    onRemove: () => void,
}

export function MultiSelectChip<T>({ option, onRemove }: IMultiSelectChipProps<T>) {
    const contentId = useId();

    function onRemoveInternal(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        onRemove();
    }

    return (
        <div
            className="multiSelect_chip"
            aria-labelledby={contentId}
        >
            <div
                className="multiSelect_chipContent"
                id={contentId}
                title={option + ''}
            >
                {option + ''}
            </div>
            <button
                className="multiSelect_chipRemoveButton"
                onClick={onRemoveInternal}
                type="button"
                // We're doing custom focus management, so we don't want this in the tab order
                aria-hidden={true}
                tabIndex={-1}
            >
                <FontAwesomeIcon icon="times" />
            </button>
        </div>
    );
}